import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface CurrentAndNewValueRowProps {
  label: string;
  currentValue: string | JSX.Element;
  customNewValueColumnWidth?: number;
  customNewValueInputLabel?: string;
  isNewValueRequired?: boolean;
  newValueInput: JSX.Element;
}

export default function CurrentAndNewValueRow({
  customNewValueColumnWidth = 6,
  isNewValueRequired = true,
  ...props
}: CurrentAndNewValueRowProps): JSX.Element {
  return (
    <Row className={css(styles.paddingTop15px)}>
      <Col md={12 - customNewValueColumnWidth}>
        <FieldLabel label={`Current ${props.label}`} labelStyle={FieldLabel.STYLES.LABEL} />
        <div className={css(styles.paddingTop5px)}>{props.currentValue}</div>
      </Col>
      <Col md={customNewValueColumnWidth}>
        <FieldLabel
          label={props.customNewValueInputLabel || `New ${props.label}`}
          labelStyle={FieldLabel.STYLES.LABEL}
          isRequired={isNewValueRequired}
        />
        {props.newValueInput}
      </Col>
    </Row>
  );
}

const styles = StyleSheet.create({
  paddingTop5px: {paddingTop: '5px'},
  paddingTop15px: {paddingTop: '15px'},
});
